export function wikiUrl(url) {
  return 'https://wiki.openstreetmap.org/wiki/' + url
}
